import {
  Area,
  AreaChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'

import { EMPTY_LIST, EMPTY_OBJECT } from '../../../constants/common'
import {
  CHART_DEFAULT_DATA_KEY,
  CHART_DEFAULT_NAME_KEY,
  CHART_POINTER_EVENTS_PROPS,
  CHART_RESPONSIVE_CONTAINER_PROPS,
  PIE_CHART_COLORS,
} from '../Chart.constants'

import {
  SPARKLINE_AREA_DEFAULT_PROPS,
  SPARKLINE_CHART_DEFAULT_PROPS,
  SPARKLINE_TOOLTIP_DEFAULT_PROPS,
  SPARKLINE_Y_AXIS_DEFAULT_PROPS,
} from './ChartSparkline.constants'

function ChartSparkline({
  areaProps = SPARKLINE_AREA_DEFAULT_PROPS,
  chartProps = SPARKLINE_CHART_DEFAULT_PROPS,
  color = PIE_CHART_COLORS[0],
  data = EMPTY_LIST,
  dataKey = CHART_DEFAULT_DATA_KEY,
  nameKey = CHART_DEFAULT_NAME_KEY,
  tooltipProps = EMPTY_OBJECT,
  yAxisProps = SPARKLINE_Y_AXIS_DEFAULT_PROPS,
}) {
  return (
    <ResponsiveContainer {...CHART_RESPONSIVE_CONTAINER_PROPS}>
      <AreaChart {...CHART_POINTER_EVENTS_PROPS} {...chartProps} data={data}>
        <XAxis hide dataKey={nameKey} />
        <YAxis {...yAxisProps} />
        <Tooltip {...SPARKLINE_TOOLTIP_DEFAULT_PROPS} {...tooltipProps} />
        <Area
          {...areaProps}
          activeDot={{ ...areaProps.activeDot, fill: color }}
          dataKey={dataKey}
          fill={color}
          stroke={color}
        />
      </AreaChart>
    </ResponsiveContainer>
  )
}

export default ChartSparkline
